export { positionElements, Positioning } from './ng-positioning'
export { PositioningService, PositioningOptions } from './positioning.service';



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/free/utils/positioning/index.ts